var protobuf = require("protobufjs");
import axios from 'axios'
const getDefaultState = () => {
    return {
        metrics: {},
    }
  }

export const state = getDefaultState()



export const getters = {
    metrics(state) {
        if(!state.metrics.length) return {}
        return state.metrics;
    } 
}

export const mutations = {
    setMetrics(state, metrics) {
        var tt = [];
        var mm = [];
        metrics.forEach((m) => {
            var a = new Date(m.datetime * 1000);
            var year = a.getFullYear();
            var month = a.getMonth()+1;
            var day = a.getDate();
            if(day < 10) day="0"+day;
            if(month < 10) month="0"+month;
            mm.push(m.datetime);
            tt.push({
                date: day+"."+month,
                id: m.datetime,
                value: m.metric,
            })

            var xx = [];
            mm = mm.sort();
            mm.forEach((i) => {
                xx.push(tt.find(e => e.id == i));
            })
            state.metrics = xx;
        })
    }
}

export const actions = {
    ClearState(state) {
        Object.assign(state, getDefaultState())
    },
    LoadGraphData(state) {
        return new Promise((resolve, reject) => {
            if(state.getters.metrics.length > 1) {
                setTimeout(() => {
                    resolve(true);
                }, 250);
            }
        })
    },
    LoadInitialData(state) {
        if(state.state.metrics.length) return false;
        return new Promise((resolve, reject) => {
            axios.get("https://poc.procomcure.com/api/v2/stats", { responseType: 'arraybuffer', headers: { Authorization: 'Berear '+state.getters.accessToken} })
            .then((r) => {
                var root = protobuf.Root.fromJSON(require("/bundle.json"));
                var Probe = root.lookupType("StatsList");          
                var message = Probe.decode(Buffer.from(r.data));
                state.commit("setMetrics", message.Stat)
                resolve(true);
            })            
        })
    }    
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }